import { http } from '../config/config-receituario'

export default {
    listar: async (token) => {
        return http.get('configuracoes', {
            headers: {
                'Authorization': token
            }
        })
    },
    salvar: (token, configuracao) => {
        return http.post('configuracoes', configuracao, {
            headers: {
                'Authorization': token
            }
        })
    },
    deletar: (token, id) => {
        return http.delete(`configuracoes/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    update: (token, configuracao) => {
        return http.put(`configuracoes/${configuracao.id}`, configuracao, {
            headers: {
                'Authorization': token
            }
        })
    }

}